// Deprecated: Use i18n keys 'entity.deposit.for_whom.*' instead
export const depositForWhomTranslations: { [key: string]: string } = {
  private_person: 'entity.deposit.for_whom.private_person',
  legal_entity: 'entity.deposit.for_whom.legal_entity',
  corporate_client: 'entity.deposit.for_whom.corporate_client',
  small_business: 'entity.deposit.for_whom.small_business'
}

export const depositForWhomKeys: { [key: string]: string } = {
  private_person: 'entity.deposit.for_whom.private_person',
  legal_entity: 'entity.deposit.for_whom.legal_entity',
  corporate_client: 'entity.deposit.for_whom.corporate_client',
  small_business: 'entity.deposit.for_whom.small_business'
}

export const relevantOptions = [
  { name: 'option_replenishment', text: 'entity.deposit.relevant_options.option_replenishment' },
  {
    name: 'option_partial_withdrawal',
    text: 'entity.deposit.relevant_options.option_partial_withdrawal'
  },
  {
    name: 'option_early_withdrawal',
    text: 'entity.deposit.relevant_options.option_early_withdrawal'
  },
  { name: 'option_prolongation', text: 'entity.deposit.relevant_options.option_prolongation' },
  {
    name: 'option_preferential_termination',
    text: 'entity.deposit.relevant_options.option_preferential_termination'
  },
  { name: 'option_seasonal_offer', text: 'entity.deposit.relevant_options.option_seasonal_offer' },
  { name: 'progressive_accrual', text: 'entity.deposit.relevant_options.progressive_accrual' }
] as const
